import { useCustomerDataQualityGate } from '@components/UserGroupDataQuality/useCustomerDataQualityCheckout';
import { Trans } from '@lingui/react/macro';
import { NoddiButton } from 'noddi-ui-web';

type Props = {
  willPay: boolean;
  isPending: boolean;
  isLoggedIn: boolean;
  onContinue: () => void;
};

/** Shares the page's data-quality sheet. Saving the last step continues this click. */
export const ConfirmProposalBookingButton = ({ willPay, isPending, isLoggedIn, onContinue }: Props) => {
  const dataQuality = useCustomerDataQualityGate();

  return (
    <NoddiButton
      loading={isPending}
      disabled={!isLoggedIn || isPending || dataQuality.isChecking}
      variant='success'
      className='w-full md:w-fit'
      onClick={() => {
        if (dataQuality.holdForDataQuality({ willPay, onSaved: onContinue }) !== 'clear') {
          return;
        }
        onContinue();
      }}
    >
      {willPay ? <Trans>Confirm and pay</Trans> : <Trans>Confirm booking</Trans>}
    </NoddiButton>
  );
};
